import React from 'react';
import ProcessMasterContainer from '../../containers/manufacturingmng/process/ProcessMasterContainer';

const ProcessMasterPage = () => {
  return <ProcessMasterContainer />;
};

export default ProcessMasterPage;
